export default "__VITE_ASSET__xJSVm7dj__"